import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { satisfactionSurvey, getSurveyTypeOptions, prepareSubtypeIcons } from './helpers'

const EmailPreview = ({ type, buildingName, subtype, questions }) => {
  const { t } = useTranslation(['surveys'])
  return (
    <div className="email-preview">
      <div className="email-preview__title">
        <span>{buildingName}</span>
        <span>{type === satisfactionSurvey ? getSurveyTypeOptions(t)[0].label : type}</span>
      </div>
      {questions.map((question, index) => (
        <div className="email-preview__content" key={index}>
          <div className="email-preview__question">{question.title}</div>
          <div className="email-preview__text">
            {type === satisfactionSurvey
              ? t('surveys:preview.rateFeelings')
              : t('surveys:preview.chooseSingleChoice')}
          </div>
          {type === satisfactionSurvey ? (
            prepareSubtypeIcons(t, subtype)
          ) : (
            <div className="email-preview__answers-list">
              {question.answerOptions.map((answer, index) => (
                <div
                  className={`email-preview__answer ${
                    index === 1 && answer ? 'email-preview__answer--selected' : ''
                  }`}
                  key={index}
                >
                  {answer}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
      <div className="email-preview__divider" />
      <div>
        <div className="email-preview__subtitle">{buildingName}</div>
        <div className="email-preview__text">
          {t('surveys:preview.poweredByText', { buildingName })}
        </div>
        <div className="email-preview__buttons">
          <img src="/images/get-appstore-app.svg" alt={t('surveys:preview.appStoreAlt')} />
          <img src="/images/get-google-play-app.svg" alt={t('surveys:preview.googlePlayAlt')} />
        </div>
      </div>
    </div>
  )
}

EmailPreview.propTypes = {
  buildingName: PropTypes.string,
  type: PropTypes.string,
  subtype: PropTypes.string,
  questions: PropTypes.array,
}

export default EmailPreview
